import "./App.css";
import { Routes, Route } from "react-router-dom";
import Projects from "./Projects";
import About from "./About";
import Welcome from "./Welcome";

function App() {
	return (
		<div className='App'>
			<div className='container'>
				<div className='frame'>
					{/* New Grid */}
					<Routes>
						<Route path='/' element={<Welcome />} />
						<Route path='/welcome' element={<Welcome />} />
						<Route path='/about' element={<About />} />
						<Route path='/projects' element={<Projects />} />
						<Route />
					</Routes>
					{/* New Grid */}
					<div className='row justify-content-end'>
						<div className='col-sm-auto bottomtag shadow'>
							<p>Design by <a href="http://www.colindick.com/" className="link">Colin Dick</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
